import { render } from "./Compass.vue?vue&type=template&id=39124bb4"
import script from "./Compass.vue?vue&type=script&lang=js"
export * from "./Compass.vue?vue&type=script&lang=js"

import "./Compass.vue?vue&type=style&index=0&id=39124bb4&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__